import * as yup from 'yup';

import signatureFields from 'features/consults/shared/tabs/Signature/formFields';
import { requiredString } from 'utils/constants';
import { isEegcptCodeCodeRequired } from 'features/consults/utils/validators';

const getSignatureValidationSchema = (consult, consultFacility) =>
  yup.object().shape({
    [signatureFields.attestationOfEEGCompletion.name]: yup
      .string()
      .required(requiredString)
      .typeError(requiredString),

    [signatureFields.eegcptCodes.name]: isEegcptCodeCodeRequired(
      consult,
      consultFacility,
    )
      ? yup.array().of(yup.number().required()).min(1, requiredString)
      : yup.array().notRequired(),

    [signatureFields.icdCodes.name]: isEegcptCodeCodeRequired(
      consult,
      consultFacility,
    )
      ? yup.array().min(1, requiredString)
      : yup.array().notRequired(),
  });

export default getSignatureValidationSchema;
